import React from 'react';

export const TopBar = () => {
    return (
        <div className="top-bar">
            <div className="top-bar-content">
                <h1 className="app-title">Keep Sticky Notes</h1>
            </div>
        </div>
    );
};